export class Priority {
  constructor(
    public id: number | null,
    public value: string,
    public color: string,
    public importance: number
  ) {}

  public static get EMPTY(): Priority {
    return new Priority(null, "", "", 0);
  }

  hasValidValue(): boolean {
    return !!this.value && this.value.trim().length > 0;
  }
}
